var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEntitiesWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.795,
    height: 30.184,
    viewBox: "0 0 27.795 30.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4428",
    "data-name": "Group 4428",
    transform: "translate(9587 3047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M28.075,21.011H2.22a1.083,1.083,0,0,0,0,2.154H28.075a1.083,1.083,0,0,0,0-2.154Z",
    transform: "translate(-9588.25 -3039.98)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M19.762,30.6V4a2.512,2.512,0,0,0-3.446-2.332L4.829,6.263A2.512,2.512,0,0,0,3.25,8.6v22a1.076,1.076,0,0,0,1.077,1.077H18.685A1.076,1.076,0,0,0,19.762,30.6ZM8.634,27.365h5.743a1.077,1.077,0,0,0,0-2.154H8.634a1.077,1.077,0,0,0,0,2.154Zm0-5.025h5.743a1.077,1.077,0,0,0,0-2.154H8.634a1.077,1.077,0,0,0,0,2.154Zm0-5.025h5.743a1.077,1.077,0,0,0,0-2.154H8.634a1.077,1.077,0,0,0,0,2.154Zm0-5.025h5.743a1.077,1.077,0,1,0,0-2.154H8.634a1.077,1.077,0,0,0,0,2.154Z",
    transform: "translate(-9588.921 -3048.488)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M15.823,7.011V28.189a2.5,2.5,0,0,1-.241,1.077h6.343A1.076,1.076,0,0,0,23,28.189V9.524A2.514,2.514,0,0,0,20.49,7.011Z",
    transform: "translate(-9583.546 -3046.082)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEntitiesWt);
export default __webpack_public_path__ + "static/media/ico_entities_wt.053c6afa4d2cda7f858c11f10a54d0f0.svg";
export { ForwardRef as ReactComponent };